var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEdite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.8802 11.9428L41.5574 16.6178L36.8802 11.9428ZM39.8879 7.82423L27.2408 20.4714C26.5873 21.1239 26.1416 21.9553 25.96 22.8608L24.7917 28.7084L30.6394 27.538C31.5448 27.3569 32.3752 26.9131 33.0288 26.2594L45.676 13.6123C46.056 13.2322 46.3575 12.781 46.5632 12.2845C46.7688 11.7879 46.8747 11.2557 46.8747 10.7183C46.8747 10.1808 46.7688 9.64858 46.5632 9.15202C46.3575 8.65546 46.056 8.20428 45.676 7.82423C45.2959 7.44418 44.8447 7.14271 44.3482 6.93703C43.8516 6.73135 43.3194 6.62549 42.7819 6.62549C42.2445 6.62549 41.7123 6.73135 41.2157 6.93703C40.7191 7.14271 40.268 7.44418 39.8879 7.82423V7.82423Z",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4584 33.1251V39.7501C42.4584 40.9215 41.993 42.0448 41.1648 42.8731C40.3365 43.7014 39.2131 44.1667 38.0417 44.1667H13.75C12.5787 44.1667 11.4553 43.7014 10.627 42.8731C9.7987 42.0448 9.33337 40.9215 9.33337 39.7501V15.4584C9.33337 14.287 9.7987 13.1636 10.627 12.3354C11.4553 11.5071 12.5787 11.0417 13.75 11.0417H20.375",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdite);
export default __webpack_public_path__ + "static/media/Icon-edite.4d152e4f3607b33054a43f7063c9ac61.svg";
export { ForwardRef as ReactComponent };